import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { AUCTION_CARS_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useAuctionCarsSocket'
import { useUpdateCar } from '@autobid/ui/composables/car/useUpdateCar'

export function useAuctionCarsCarInPrepare() {
  const { startListen } = useWebSocketStore()
  const { updateAuctionCar } = useUpdateCar()

  const carInPrepare = () => {
    startListen({
      eventName: 'premium.CAR_IN_PREPARE',
      callbackName: AUCTION_CARS_SOCKET_CALLBACK,
      callback: (event) => {
        const { carId } = event.context

        updateAuctionCar('unknown', carId, (data) => {
          return {
            ...data,
            stage: 'IN_PREPARATION',
          }
        })
      },
    })
  }

  return { carInPrepare }
}
